import CategoryStatusBadge from "./CategoryStatusBadge";
import "../styles/category-table.css";
const CategoryTable = ({
  categories = [],
  loading = false,
  onView,
  onEdit,
  onDelete,
  onToggleStatus
}) => {
  if (loading) {
    return (
      <div className="category-table-message">
        Loading categories...
      </div>
    );
  }

  if (!categories.length) {
    return (
      <div className="category-table-empty">
        <p className="category-empty-title">
          No categories found
        </p>

        <p className="category-empty-description">
          Create your first category to get started.
        </p>
      </div>
    );
  }

  return (
    <div className="category-table-wrapper">
      <div className="category-table-scroll">
        <table className="category-table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Slug</th>
              <th>Order</th>
              <th>Status</th>
              <th className="category-actions-header">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {categories.map((category) => (
              <tr key={category.id}>
                <td>
                  <div className="category-name-cell">
                    <p className="category-name">
                      {category.name}
                    </p>

                    {category.description && (
                      <p className="category-description">
                        {category.description}
                      </p>
                    )}
                  </div>
                </td>

                <td>
                  <span className="category-slug">
                    {category.slug}
                  </span>
                </td>

                <td>
                  <span className="category-order">
                    {category.display_order}
                  </span>
                </td>

                <td>
                  <CategoryStatusBadge
                    isActive={category.is_active}
                  />
                </td>

                <td>
                  <div className="category-actions">
                    <button
                      type="button"
                      onClick={() =>
                        onView(category)
                      }
                      className="category-action category-action-view"
                    >
                      View
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        onEdit(category)
                      }
                      className="category-action category-action-edit"
                    >
                      Edit
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        onToggleStatus(category)
                      }
                      className="category-action category-action-status"
                    >
                      {category.is_active
                        ? "Deactivate"
                        : "Activate"}
                    </button>

                    {onDelete && (
                      <button
                        type="button"
                        onClick={() =>
                          onDelete(category)
                        }
                        className="category-action category-action-delete"
                      >
                        Delete
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CategoryTable;